import { apiGet } from 'App/Dataman';
import { NEWSLETTER_PATHS } from '@/app/api/newsletter/paths';

export function getNewsletterEmails(params = {}) {
  return apiGet(NEWSLETTER_PATHS.newsletterEmails, { params });
}

export function getNewsletterDomains(params = {}) {
  return apiGet(NEWSLETTER_PATHS.newsletterDomains, { params });
}

export function getNewsletterEmailById(id) {
  return apiGet(`${NEWSLETTER_PATHS.newsletterEmails}/${id}`);
}

export default {
  getNewsletterEmails,
  getNewsletterDomains,
  getNewsletterEmailById,
};
